/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { InventoryCatalogFromJSON, InventoryCatalogToJSON, } from './InventoryCatalog';
import { InventoryPricingFromJSON, InventoryPricingToJSON, } from './InventoryPricing';
import { InventorySourceFromJSON, InventorySourceToJSON, } from './InventorySource';
import { PendingDeletionReasonDTOFromJSON, PendingDeletionReasonDTOToJSON, } from './PendingDeletionReasonDTO';
/**
 * @export
 */
export const InventoryDTOTargetMarketEnum = {
    UnitedStates: 'UNITED_STATES',
    Brazil: 'BRAZIL',
    Canada: 'CANADA',
    Mexico: 'MEXICO',
    Australia: 'AUSTRALIA',
    Japan: 'JAPAN',
    India: 'INDIA',
    Singapore: 'SINGAPORE',
    Germany: 'GERMANY',
    Spain: 'SPAIN',
    France: 'FRANCE',
    Italy: 'ITALY',
    Netherlands: 'NETHERLANDS',
    Belgium: 'BELGIUM',
    Poland: 'POLAND',
    Sweden: 'SWEDEN',
    UnitedKingdom: 'UNITED_KINGDOM',
    Ireland: 'IRELAND',
    UnitedArabEmirates: 'UNITED_ARAB_EMIRATES',
    Egypt: 'EGYPT',
    SaudiArabia: 'SAUDI_ARABIA',
    All: 'ALL'
};
/**
 * @export
 */
export const InventoryDTOCompetitionLevelEnum = {
    Weak: 'WEAK',
    Medium: 'MEDIUM',
    Strong: 'STRONG'
};
/**
 * @export
 */
export const InventoryDTODecisionEnum = {
    Saleable: 'SALEABLE',
    Recheck: 'RECHECK',
    Unsaleable: 'UNSALEABLE'
};
/**
 * @export
 */
export const InventoryDTOInventoryStatusEnum = {
    Active: 'ACTIVE',
    Inactive: 'INACTIVE',
    Incomplete: 'INCOMPLETE',
    Creating: 'CREATING',
    Deleting: 'DELETING'
};
/**
 * @export
 */
export const InventoryDTOInactiveReasonEnum = {
    DetailPageRemoved: 'DETAIL_PAGE_REMOVED',
    PricingIssue: 'PRICING_ISSUE',
    OutOfStock: 'OUT_OF_STOCK',
    GpsrMissing: 'GPSR_MISSING',
    ApprovalRequired: 'APPROVAL_REQUIRED',
    Unknown: 'UNKNOWN'
};
/**
 * @export
 */
export const InventoryDTOUpdateActionEnum = {
    UpdateRequired: 'UPDATE_REQUIRED',
    DeleteRequired: 'DELETE_REQUIRED',
    SetInactiveRequired: 'SET_INACTIVE_REQUIRED',
    SetActiveRequired: 'SET_ACTIVE_REQUIRED',
    MaxOrderQuantityRequired: 'MAX_ORDER_QUANTITY_REQUIRED',
    HandlingTimeRequired: 'HANDLING_TIME_REQUIRED',
    PriceForceRequired: 'PRICE_FORCE_REQUIRED',
    PriceForceCloseRequired: 'PRICE_FORCE_CLOSE_REQUIRED'
};
/**
 * Check if a given object implements the InventoryDTO interface.
 */
export function instanceOfInventoryDTO(value) {
    return true;
}
export function InventoryDTOFromJSON(json) {
    return InventoryDTOFromJSONTyped(json, false);
}
export function InventoryDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'] == null ? undefined : json['id'],
        'asin': json['asin'] == null ? undefined : json['asin'],
        'sku': json['sku'] == null ? undefined : json['sku'],
        'quantity': json['quantity'] == null ? undefined : json['quantity'],
        'targetMarket': json['targetMarket'] == null ? undefined : json['targetMarket'],
        'competitionLevel': json['competitionLevel'] == null ? undefined : json['competitionLevel'],
        'decision': json['decision'] == null ? undefined : json['decision'],
        'inventoryStatus': json['inventoryStatus'] == null ? undefined : json['inventoryStatus'],
        'inactiveReason': json['inactiveReason'] == null ? undefined : json['inactiveReason'],
        'updateAction': json['updateAction'] == null ? undefined : json['updateAction'],
        'pendingDeletionAt': json['pendingDeletionAt'] == null ? undefined : (new Date(json['pendingDeletionAt'])),
        'pendingDeletionReason': json['pendingDeletionReason'] == null ? undefined : PendingDeletionReasonDTOFromJSON(json['pendingDeletionReason']),
        'decisionReasons': json['decisionReasons'] == null ? undefined : json['decisionReasons'],
        'shippingPriceUsd': json['shippingPriceUsd'] == null ? undefined : json['shippingPriceUsd'],
        'dutyUsd': json['dutyUsd'] == null ? undefined : json['dutyUsd'],
        'shippingCarrier': json['shippingCarrier'] == null ? undefined : json['shippingCarrier'],
        'saleTaxPriceUsd': json['saleTaxPriceUsd'] == null ? undefined : json['saleTaxPriceUsd'],
        'totalCostUsd': json['totalCostUsd'] == null ? undefined : json['totalCostUsd'],
        'currencyRate': json['currencyRate'] == null ? undefined : json['currencyRate'],
        'minProfit': json['minProfit'] == null ? undefined : json['minProfit'],
        'minProfitUsd': json['minProfitUsd'] == null ? undefined : json['minProfitUsd'],
        'maxProfit': json['maxProfit'] == null ? undefined : json['maxProfit'],
        'maxProfitUsd': json['maxProfitUsd'] == null ? undefined : json['maxProfitUsd'],
        'minSellingPrice': json['minSellingPrice'] == null ? undefined : json['minSellingPrice'],
        'minSellingPriceUsd': json['minSellingPriceUsd'] == null ? undefined : json['minSellingPriceUsd'],
        'maxSellingPrice': json['maxSellingPrice'] == null ? undefined : json['maxSellingPrice'],
        'maxSellingPriceUsd': json['maxSellingPriceUsd'] == null ? undefined : json['maxSellingPriceUsd'],
        'referralFee': json['referralFee'] == null ? undefined : json['referralFee'],
        'referralFeeUsd': json['referralFeeUsd'] == null ? undefined : json['referralFeeUsd'],
        'sellingPriceNetOfVat': json['sellingPriceNetOfVat'] == null ? undefined : json['sellingPriceNetOfVat'],
        'sellingPriceNetOfVatUsd': json['sellingPriceNetOfVatUsd'] == null ? undefined : json['sellingPriceNetOfVatUsd'],
        'vatAmount': json['vatAmount'] == null ? undefined : json['vatAmount'],
        'vatAmountUsd': json['vatAmountUsd'] == null ? undefined : json['vatAmountUsd'],
        'profit': json['profit'] == null ? undefined : json['profit'],
        'profitUsd': json['profitUsd'] == null ? undefined : json['profitUsd'],
        'sellingPrice': json['sellingPrice'] == null ? undefined : json['sellingPrice'],
        'sellingPriceUsd': json['sellingPriceUsd'] == null ? undefined : json['sellingPriceUsd'],
        'appliedPromotionShare': json['appliedPromotionShare'] == null ? undefined : json['appliedPromotionShare'],
        'sourceReviewRating': json['sourceReviewRating'] == null ? undefined : json['sourceReviewRating'],
        'sourceReviewCount': json['sourceReviewCount'] == null ? undefined : json['sourceReviewCount'],
        'sourceBoughtPastMonth': json['sourceBoughtPastMonth'] == null ? undefined : json['sourceBoughtPastMonth'],
        'amILowest': json['amILowest'] == null ? undefined : json['amILowest'],
        'amIBuybox': json['amIBuybox'] == null ? undefined : json['amIBuybox'],
        'createdDate': json['createdDate'] == null ? undefined : (new Date(json['createdDate'])),
        'buyboxSellerId': json['buyboxSellerId'] == null ? undefined : json['buyboxSellerId'],
        'lowestSellerId': json['lowestSellerId'] == null ? undefined : json['lowestSellerId'],
        'handlingTimeDays': json['handlingTimeDays'] == null ? undefined : json['handlingTimeDays'],
        'handlingTimeSynced': json['handlingTimeSynced'] == null ? undefined : json['handlingTimeSynced'],
        'source': json['source'] == null ? undefined : InventorySourceFromJSON(json['source']),
        'pricing': json['pricing'] == null ? undefined : InventoryPricingFromJSON(json['pricing']),
        'catalog': json['catalog'] == null ? undefined : InventoryCatalogFromJSON(json['catalog']),
    };
}
export function InventoryDTOToJSON(json) {
    return InventoryDTOToJSONTyped(json, false);
}
export function InventoryDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'asin': value['asin'],
        'sku': value['sku'],
        'quantity': value['quantity'],
        'targetMarket': value['targetMarket'],
        'competitionLevel': value['competitionLevel'],
        'decision': value['decision'],
        'inventoryStatus': value['inventoryStatus'],
        'inactiveReason': value['inactiveReason'],
        'updateAction': value['updateAction'],
        'pendingDeletionAt': value['pendingDeletionAt'] == null ? undefined : ((value['pendingDeletionAt']).toISOString()),
        'pendingDeletionReason': PendingDeletionReasonDTOToJSON(value['pendingDeletionReason']),
        'decisionReasons': value['decisionReasons'],
        'shippingPriceUsd': value['shippingPriceUsd'],
        'dutyUsd': value['dutyUsd'],
        'shippingCarrier': value['shippingCarrier'],
        'saleTaxPriceUsd': value['saleTaxPriceUsd'],
        'totalCostUsd': value['totalCostUsd'],
        'currencyRate': value['currencyRate'],
        'minProfit': value['minProfit'],
        'minProfitUsd': value['minProfitUsd'],
        'maxProfit': value['maxProfit'],
        'maxProfitUsd': value['maxProfitUsd'],
        'minSellingPrice': value['minSellingPrice'],
        'minSellingPriceUsd': value['minSellingPriceUsd'],
        'maxSellingPrice': value['maxSellingPrice'],
        'maxSellingPriceUsd': value['maxSellingPriceUsd'],
        'referralFee': value['referralFee'],
        'referralFeeUsd': value['referralFeeUsd'],
        'sellingPriceNetOfVat': value['sellingPriceNetOfVat'],
        'sellingPriceNetOfVatUsd': value['sellingPriceNetOfVatUsd'],
        'vatAmount': value['vatAmount'],
        'vatAmountUsd': value['vatAmountUsd'],
        'profit': value['profit'],
        'profitUsd': value['profitUsd'],
        'sellingPrice': value['sellingPrice'],
        'sellingPriceUsd': value['sellingPriceUsd'],
        'appliedPromotionShare': value['appliedPromotionShare'],
        'sourceReviewRating': value['sourceReviewRating'],
        'sourceReviewCount': value['sourceReviewCount'],
        'sourceBoughtPastMonth': value['sourceBoughtPastMonth'],
        'amILowest': value['amILowest'],
        'amIBuybox': value['amIBuybox'],
        'createdDate': value['createdDate'] == null ? undefined : ((value['createdDate']).toISOString()),
        'buyboxSellerId': value['buyboxSellerId'],
        'lowestSellerId': value['lowestSellerId'],
        'handlingTimeDays': value['handlingTimeDays'],
        'handlingTimeSynced': value['handlingTimeSynced'],
        'source': InventorySourceToJSON(value['source']),
        'pricing': InventoryPricingToJSON(value['pricing']),
        'catalog': InventoryCatalogToJSON(value['catalog']),
    };
}
